/*----------------------------------------*\
  UI HELPER
\*----------------------------------------*/

import Definition from 'vue-pages/components/Definition';

/**
 * Update an SVG icon ID
 * @param  {Element} node  The SVG element
 * @param  {String}  id    The id of the icon to display
 */
export function updateIcon(node, id) {
  const use = node.querySelector('use');
  const link = use.getAttribute('xlink:href');
  const newLink = link.replace(/#([\s\S]+)$/, `#${id}`);

  use.setAttribute('xlink:href', newLink);
}


/**
 * Listen to display Glossary terms in popovers
 */
export function bindDefinitions() {
  const links = [...document.querySelectorAll('.definition')];
  links.forEach(link => {
    link.addEventListener('click', e =>  {
      e.preventDefault(); // Cancel the native event
      e.stopPropagation();// Don't bubble/capture the event any further
      const def = e.target;
      const id = def.dataset && def.dataset.glossaryId;

      if (id) {
        if (def.popoverDefinition) {
          def.popoverDefinition.show();
        } else {
          const wrapper = document.createElement('div');
          def.parentElement.appendChild(wrapper);

          def.popoverDefinition = new Definition({
            data: {
              id,
              reference: def,
              labels: window.APP.definitions.labels,
              routes: window.APP.definitions.routes,
            },
          }).$mount(wrapper);
        }
      }
    });
  });
}
